import React, { Component } from 'react';
import './styles';
import { connect } from 'react-redux';
import Queries from '../../../../../../utils/API/Queries';
import PLMap from '../../../../../../components/PL/PLMap';
import { withApollo } from '@apollo/react-hoc';
import UIModal from '../../../../../../components/UI/UIModal';
import UIIconButton from '../../../../../../components/UI/UIIconButton';
import { commonMapDispatchToProps, commonMapStateToProps } from '../../../../../../utils/Helpers/AppHelper';
import RegionZipModal from './RegionZipModal';
import * as strings from './strings';
import { PlusIcon } from '../../../../../../assets/icons';
import { SOURCES, ZIP_CODES_STYLE } from '../../../../../../components/PL/PLMap/config';
import { toast } from 'react-toastify';

let ReactMapboxGl, Layer, Feature, Popup, Source;
if (process.env.BUILD_TARGET === 'client') {
	ReactMapboxGl = require('react-mapbox-gl');
	Layer = ReactMapboxGl.Layer;
	Feature = ReactMapboxGl.Feature;
	Popup = ReactMapboxGl.Popup;
	Source = ReactMapboxGl.Source;
}
let delay = 200;
let prevent = false;
let doubleClick = false;

class RegionServiceArea extends Component {
	constructor(props) {
		super(props);

		this.state = { searchFilter: '' };
	}

	//Mark: Component functions
	addZipCodeMap = async (zipCode) => {
		let zipCodes = this.props.currentUser.selectedRegion['zipCodes'];
		zipCodes.push(zipCode);

		const response = await this.props.client
			.mutate({
				mutation: Queries.UPDATE_REGION,
				variables: { id: this.props.currentUser.selectedRegion.id, zipCodes }
			})
			.catch((error) => toast.error(error.message));
		const { updateRegion } = response['data'];
		if (updateRegion) {
			let region = Object.assign({}, this.props.currentUser.selectedRegion);
			region.zipCodes = updateRegion.zipCodes;
			this.props.setSelectedRegion(region);
			this.setState({ showAddZipModal: false, zipCode: null, isLoading: false });
			toast.success(strings.successAddZipcode(zipCode));
		}
	};

	removeZipCode = async (zipCode) => {
		let zipCodes = this.props.currentUser.selectedRegion['zipCodes'].filter((e) => e !== zipCode);
		const response = await this.props.client
			.mutate({
				mutation: Queries.UPDATE_REGION,
				variables: { id: this.props.currentUser.selectedRegion.id, zipCodes }
			})
			.catch((error) => toast.error(error.message));
		const { updateRegion } = response['data'];
		if (updateRegion) {
			let region = Object.assign({}, this.props.currentUser.selectedRegion);
			region.zipCodes = updateRegion.zipCodes;
			this.props.setSelectedRegion(region);
			toast.success(strings.successRemovingZipcode(zipCode));
		} else {
			toast.error(strings.errorRemovingZipcode);
		}
	};

	_onMapClick = (map, evt) => {
		if (prevent === true) {
			doubleClick = true;
			return;
		}
		this.timer = setTimeout(async () => {
			if (doubleClick === false) {
				const features = map.queryRenderedFeatures(evt.point).filter((feature) => feature.source === 'zipSource');
				if (features.length > 0) {
					let feature = features[0];
					const { GEOID10: GEOID } = feature.properties;
					if (features.filter((feature) => feature.layer.id === 'layer_id').length > 0) {
						let zips = map.getFilter('layer_id');
						const { GEOID10 } = feature.properties;
						let index = zips.indexOf(GEOID10);
						if (index > -1) {
							zips.splice(index, 1);
						}
						map.setFilter('layer_id', zips);
						await this.removeZipCode(GEOID);
					} else if (features.filter((feature) => feature.layer.id === 'unselectedLayerId').length > 0) {
						await this.addZipCodeMap(GEOID);
						let zips = map.getFilter('layer_id');
						zips.push(GEOID);
						map.setFilter('layer_id', zips);
					} else {
						toast.error(strings.successClickZip(GEOID));
					}
				}
			}
			prevent = false;
			doubleClick = false;
		}, delay);
		prevent = true;
	};

	//Mark: Render functions
	render() {
		const zipCodes = this.props.currentUser.selectedRegion['zipCodes'];

		return (
			<div className='regionServiceArea'>
				{this.renderMap(zipCodes)}
				{this.addZipCodeButton()}
				{this.renderZipcodeModal()}
			</div>
		);
	}

	renderZipcodeModal = () => {
		const { showZipcodeModal } = this.state;
		const hideModal = () => {
			this.setState({ showZipcodeModal: false });
		};
		return (
			<UIModal condition={showZipcodeModal} hideModal={hideModal}>
				<RegionZipModal hideModal={hideModal} />
			</UIModal>
		);
	};

	addZipCodeButton = () => {
		return (
			<UIIconButton
				icon={PlusIcon.darkGrey}
				iconPadding={3}
				className='regionServiceArea__button'
				dark
				text={strings.addZipcodeButton}
				onClick={() => this.setState({ showZipcodeModal: true })}
			/>
		);
	};

	renderMap = (zipCodes) => {
		let regionZipsArray = ['in', 'GEOID10'];
		regionZipsArray.push.apply(regionZipsArray, zipCodes);
		return (
			<PLMap
				style={ZIP_CODES_STYLE}
				center={[this.props.currentUser.selectedRegion.longitude, this.props.currentUser.selectedRegion.latitude]}
				zoom={[6]}
				setFlyTo={this.props.setFlyTo}
				onClick={this._onMapClick}
				noLocation
				containerClassName='regionServiceArea--map'>
				<Source id='zipSource' tileJsonSource={SOURCES.US_ZIP_CODES} />
				<Layer
					type='fill'
					id='layer_id'
					filter={regionZipsArray}
					paint={{
						'fill-color': '#5cb85c',
						'fill-opacity': 0.25
					}}
					before={'road-label'}
					sourceId={'zipSource'}
					sourceLayer='zcta5-8785yf'
				/>
				<Layer
					type='line'
					id='outlineLayerId'
					paint={{
						'line-color': '#FFFFFF',
						'line-opacity': 0.15,
						'line-width': 1
					}}
					minZoom={6}
					before={'layer_id'}
					sourceId={'zipSource'}
					sourceLayer='zcta5-8785yf'
				/>
				<Layer
					type='fill'
					id='unselectedLayerId'
					paint={{
						'fill-color': '#FFFFFF',
						'fill-opacity': 0
					}}
					minZoom={6}
					before={'layer_id'}
					sourceId={'zipSource'}
					sourceLayer='zcta5-8785yf'
				/>
			</PLMap>
		);
	};
}

export default withApollo(connect(commonMapStateToProps, commonMapDispatchToProps)(RegionServiceArea));
